const LocalStorage = (namespace) => {
    const storage = JSON.parse(localStorage.getItem(namespace)) || {};

    /**
     * Writes the storage into the client's localStorage.
     *
     * @returns {boolean}
     */
    const store = function () {
        localStorage.setItem(namespace, JSON.stringify(storage));

        return true;
    };

    /**
     * Receives the key in the storage Object.
     *
     * @param {string} key
     * @returns {string}
     */
    const get = function (key) {
        return storage[key] || null;
    };

    /**
     * Checks if the key exists in the storage Object.
     *
     * @param {string} key
     * @returns {boolean}
     */
    const has = function (key) {
        return !!storage[key];
    };

    /**
     * Deletes the key in the storage Object.
     *
     * @param {string} key
     * @returns {boolean}
     */
    const remove = function (key) {
        delete storage[key];

        return store();
    };

    /**
     * Sets the key in the storage Object.
     *
     * @param {string} key
     * @param {*} value
     * @returns {boolean}
     */
    const set = function (key, value) {
        storage[key] = value;

        return store();
    };

    return {
        get: get,
        has: has,
        remove: remove,
        set: set,
    };
};

export default LocalStorage;



// WEBPACK FOOTER //
// ./src/storage/local.js